import { gql } from '@apollo/client'

export const UPDATE_USER_ACCOUNT = gql`
  mutation UpdateUserAccount($input: UpdateUserAccountInput!) {
    updateUserAccount(input: $input) {
      userAccount {
        id
        email
        sub
        emailVerified
        name
        picture
        firstName
        lastName
        fullName
        displayName
        roles
        createdAt
        updatedAt
      }
      errors
    }
  }
`
